<div class="pr-com-summary-box pr-column-box">
  <div class="pr-com-summary-col">
    <div class="com-pr-summary-first-block">
      <div class="com-pr-summary-first-title">Portfolio</div>
      <div class="com-pr-summary-first-value">
        @if (data.portfolioDeleted) {
          <span id="recordPortfolioName1">{{data.portfolioName}}</span>
        }
        @if (!data.portfolioDeleted) {
          <span id="recordPortfolioName2">
            <a (click)="editPortfolio()" data-portfolio-name-link>{{data.portfolioName}}</a>
          </span>
        }
      </div>
    </div>

    <div class="com-pr-summary-first-block">
      <div class="com-pr-summary-first-title">Market Value</div>
      <div class="com-pr-summary-first-value">
        <span>{{data.preRebalPfMktValue | number:"1.2-2" | negativeNumber: '$'}}</span>
      </div>
    </div>

    <div class="com-pr-summary-first-block">
      <div class="com-pr-summary-first-title">Current Model</div>
      <div class="com-pr-summary-first-value">
        @if (data.modelDeleted) {
          <span id="recordModelName">{{data.modelName}}</span>
        }
        @if (!data.modelDeleted) {
          <span id="recordModelName1">
            <a (click)="editModel()" data-model-name-link>{{data.modelName}}</a>
          </span>
        }
      </div>
    </div>

    <div class="com-pr-summary-first-block">
      <div class="com-pr-summary-first-title">Completed</div>
      <div class="com-pr-summary-first-value">
        <span id="recordCompletionDate">{{data.completionDate | date: 'E MM/dd/yyyy hh:mm:ss a'}}</span>
      </div>
    </div>

    <div class="com-pr-summary-first-block">
      <div class="com-pr-summary-first-title">Last Rebalance Result</div>
      <div class="com-pr-summary-first-value">
        {{data.latestRebalanceDate | date: 'E MM/dd/yyyy hh:mm:ss a'}}
        <br/>
        @if (data.latestRebalanceName && data.latestRebalanceId) {
          <a data-latest-rebalance-link (click)="editPortfolioById(data.latestRebalanceId)"
          >{{data.latestRebalanceName}}</a>
        }
      </div>
    </div>

    <div class="com-pr-summary-first-block">
      <div class="com-pr-summary-first-title">Next Rebalance</div>
      <div class="com-pr-summary-first-value">
        @if (data.schRebalanceDate) {
          <span
          id="nextRebalanceDate">{{data.schRebalanceDate | date: 'E MM/dd/yyyy hh:mm:ss a'}}</span>
        }
      </div>
    </div>

    @if (data.schRebalanceDate && data.schRebalanceName) {
      <div class="com-pr-summary-first-block">
        <div class="com-pr-summary-first-title"></div>
        <div class="com-pr-summary-first-value">
          <a href="#" id="nextRebalanceName">{{data.schRebalanceName}}</a>
        </div>
      </div>
    }

    <div class="com-pr-summary-first-block">
      <div class="com-pr-summary-first-title">High-priority Notes</div>
      <div class="com-pr-summary-first-value">
        @if (data.hpnNo === 0) {
          <span>0</span>
        }
        @if (data.hpnNo > 0) {
          <span><a (click)="editPortfolio({notesinit: true})"
          data-notes-link>{{data.hpnNo}}</a></span>
        }
      </div>
    </div>

    <div class="com-pr-summary-first-block">
      <div class="com-pr-summary-first-title">Restrictions</div>
      <div class="com-pr-summary-first-value">
        @if (data.psrNo === 0) {
          <span>0</span>
        }
        @if (data.psrNo > 0) {
          <span><a (click)="editPortfolio({restrictionsinit : true})"
          data-restrictions-link>{{data.psrNo}}</a></span>
        }
      </div>
    </div>

    <div class="com-pr-summary-first-block ">
      <div class="com-pr-summary-first-title">Trade Explanation</div>
      <div class="com-pr-summary-first-value trade-explanation-input-wrapper">
        <input (input)="onInputChange()" [(ngModel)]="data.tradeExplanation" id="tradeExplanation" pInputText
          style="width:100%" type="text" [maxlength]="255"/>
      </div>
    </div>
  </div>

  <div class="pr-com-summary-col">
    <table class="tbl-com-pr-summary-table-box">
      <tr>
        <td class="bold com-pr-headers com-pr-title-column" rowspan="2">ORDERS</td>
        <td class="bold com-pr-headers com-pr-right-border center" colspan="2">Before Advisor Edits</td>
        <td class="bold com-pr-headers center" colspan="2">After Advisor Edits</td>
      </tr>
      <tr>
        <td class="bold alignRight com-pr-headers">Qty</td>
        <td class="bold alignRight com-pr-headers com-pr-right-border">Value</td>
        <td class="bold alignRight com-pr-headers">Qty</td>
        <td class="bold alignRight com-pr-headers">Value</td>
      </tr>

      @for (row of ordersSummary; track row) {
        <tr>
          <td [ngClass]="{'bold': row.sectionHdr}" class="com-pr-title-column">
            <span>{{row.rowHdrStr}}</span></td>
            <td [ngClass]="{'bold': row.sectionHdr}" class="alignRight">
              @if (row.quantity < 0) {
                <span></span>
              }
              @if (row.quantity >= 0) {
                <span>{{row.quantity}}</span>
              }
            </td>
            <td [ngClass]="{'bold': row.sectionHdr, 'negative': row.totValue < 0}"
              class="alignRight com-pr-right-border">
              <span>{{row.totValue | number:"1.2-2" | negativeNumber: "$"}}</span>
            </td>
            <td [ngClass]="{'bold': row.sectionHdr}" class="alignRight">
              @if (row.userQuantity < 0) {
                <span></span>
              }
              @if (row.userQuantity >= 0) {
                <span>{{row.userQuantity}}</span>
              }
            </td>
            <td [ngClass]="{'bold': row.sectionHdr, 'negative': row.userTotValue < 0}"
              class="alignRight">
              <span>{{row.userTotValue | number:"1.2-2" | negativeNumber: "$"}}</span>
            </td>
          </tr>
        }

      </table>
    </div>

    <div class="pr-com-summary-col" style="min-width:32%;">
      <table class="tbl-com-pr-summary-table-box">
        <tr>
          <td class="bold com-pr-headers com-pr-title-column" rowspan="2">TAX INFO <span class="infoIcon" calltoaction [calltoactionTemplate]="prComSummaryTaxInfoTemplateRef"></span></td>
          <td class="bold com-pr-headers com-pr-right-border center">Pre-Rebalance</td>
          <td class="bold com-pr-headers com-pr-right-border center" colspan="2">Rebalance Values (Estimated)</td>
          <td class="bold com-pr-headers com-pr-right-border center">Post-Rebalance (Estimated)</td>
        </tr>
        <tr>
          <td class="bold alignRight com-pr-headers com-pr-right-border">Realized YTD Values</td>
          <td class="bold alignRight com-pr-headers">Before Edits</td>
          <td class="bold alignRight com-pr-headers com-pr-right-border">After Edits</td>
          <td class="bold alignRight com-pr-headers com-pr-right-border">Realized YTD Values</td>
        </tr>
            @if (isGainThresholdFeatureFlagEnabled) {
          <tr>
                <td class="com-pr-title-column">Gains Threshold</td>
                <td class="alignRight com-pr-right-border"
                  id="gainsThreshold">
                  {{data.gainsThresholdAmt  | number:"1.0-0" | negativeNumber: "$"}}</td>
                <td class="alignRight">
                  <span></span>
            </td>
                <td class="alignRight com-pr-right-border">
                  <span></span>
            </td>
                <td class="alignRight com-pr-right-border"
                  id="gainsThreshold1">
                  {{data.gainsThresholdAmt  | number:"1.0-0" | negativeNumber: "$"}}</td>
          </tr>
        }
        @if (taxInfoSummary && taxInfoSummary.length > 1) {
          <tr>
            <td class="com-pr-title-column">Short-term</td>
            <td [ngClass]="{'negative': data.ytdShortTermGainLoss < 0}" class="alignRight com-pr-right-border"
              id="ytdShortTerm">
            {{data.ytdShortTermGainLoss | number:"1.0-0" | negativeNumber: "$"}}</td>
            <td [ngClass]="{'bold': taxInfoSummary[1].sectionHdr, 'negative': taxInfoSummary[1].totValue < 0}"
              class="alignRight">
              <span>{{taxInfoSummary[1].totValue | number:"1.2-2" | negativeNumber: "$"}}</span>
            </td>
                <td [ngClass]="{'bold': taxInfoSummary[1].sectionHdr, 'negative': taxInfoSummary[1].userTotValue < 0}"
                  class="alignRight com-pr-right-border">
                  <span>{{hasUserEdits() ? (taxInfoSummary[1].userTotValue | number:"1.2-2" | negativeNumber: "$") : "$0.00"}}</span>
            </td>
                <td class="alignRight com-pr-right-border"
                  id="ytdShortTerm1">
                  <span *ngIf="hasOrders() && hasUserEdits()" [ngClass]="{'negative': data.ytdShortTermGainLoss + taxInfoSummary[1].userTotValue < 0}">{{data.ytdShortTermGainLoss + taxInfoSummary[1].userTotValue | number:"1.0-0" | negativeNumber: "$"}}</span>
                  <span *ngIf="hasOrders() && !hasUserEdits()" [ngClass]="{'negative': data.ytdShortTermGainLoss + taxInfoSummary[1].totValue < 0}">{{data.ytdShortTermGainLoss + taxInfoSummary[1].totValue | number:"1.0-0" | negativeNumber: "$"}}</span>
                  <span *ngIf="!hasOrders()" [ngClass]="{'negative': data.ytdShortTermGainLoss < 0}">{{data.ytdShortTermGainLoss | number:"1.0-0" | negativeNumber: "$"}}</span>
                </td>
          </tr>
        }
        @if (taxInfoSummary && taxInfoSummary.length > 2) {
          <tr>
            <td class="com-pr-title-column">Long-term</td>
            <td [ngClass]="{'negative': data.ytdLongTermGainLoss < 0}" class="alignRight com-pr-right-border"
              id="ytdLongTerm">
            {{data.ytdLongTermGainLoss | number:"1.0-0" | negativeNumber: "$"}}</td>
            <td [ngClass]="{'bold': taxInfoSummary[2].sectionHdr, 'negative': taxInfoSummary[2].totValue < 0}"
              class="alignRight">
              <span>{{taxInfoSummary[2].totValue | number:"1.2-2" | negativeNumber: "$"}}</span>
            </td>
                <td [ngClass]="{'bold': taxInfoSummary[2].sectionHdr, 'negative': taxInfoSummary[2].userTotValue < 0}"
                  class="alignRight com-pr-right-border">
                  <span>{{hasUserEdits() ? (taxInfoSummary[2].userTotValue | number:"1.2-2" | negativeNumber: "$") : "$0.00"}}</span>
                </td>
                <td class="alignRight com-pr-right-border"
                  id="ytdLongTerm1">
                  <span *ngIf="hasOrders() && hasUserEdits()" [ngClass]="{'negative': data.ytdLongTermGainLoss + taxInfoSummary[2].userTotValue < 0}">{{data.ytdLongTermGainLoss + taxInfoSummary[2].userTotValue | number:"1.0-0" | negativeNumber: "$"}}</span>
                  <span *ngIf="hasOrders() && !hasUserEdits()" [ngClass]="{'negative': data.ytdLongTermGainLoss + taxInfoSummary[2].totValue < 0}">{{data.ytdLongTermGainLoss + taxInfoSummary[2].totValue | number:"1.0-0" | negativeNumber: "$"}}</span>
                  <span *ngIf="!hasOrders()" [ngClass]="{'negative': data.ytdLongTermGainLoss < 0}">{{data.ytdLongTermGainLoss | number:"1.0-0" | negativeNumber: "$"}}</span>
                </td>
              </tr>
            }
            @if (taxInfoSummary && taxInfoSummary.length > 0) {
              <tr>
                <td class="bold com-pr-title-column">Total gain/loss</td>
                <td [ngClass]="{'negative': data.ytdTotalGainLoss < 0}" class="bold alignRight com-pr-right-border"
                  id="ytdTotalGainLoss">
                {{data.ytdTotalGainLoss | number:"1.0-0" | negativeNumber: "$"}}</td>
                <td [ngClass]="{'bold': taxInfoSummary[0].sectionHdr, 'negative': taxInfoSummary[0].totValue < 0}"
              class="alignRight">
                  <span>{{taxInfoSummary[0].totValue | number:"1.2-2" | negativeNumber: "$"}}</span>
                </td>
                <td [ngClass]="{'bold': taxInfoSummary[0].sectionHdr, 'negative': taxInfoSummary[0].userTotValue < 0}"
                  class="alignRight com-pr-right-border">
                  <span>{{hasUserEdits() ? (taxInfoSummary[0].userTotValue | number:"1.2-2" | negativeNumber: "$") : "$0.00"}}</span>
            </td>
                <td class="bold alignRight com-pr-right-border"
                  id="ytdTotalGainLoss1">
                  <span *ngIf="hasOrders() && hasUserEdits()" [ngClass]="{'negative': data.ytdTotalGainLoss + taxInfoSummary[0].userTotValue < 0}">{{data.ytdTotalGainLoss + taxInfoSummary[0].userTotValue | number:"1.0-0" | negativeNumber: "$"}}</span>
                  <span *ngIf="hasOrders() && !hasUserEdits()" [ngClass]="{'negative': data.ytdTotalGainLoss + taxInfoSummary[0].totValue < 0}">{{data.ytdTotalGainLoss + taxInfoSummary[0].totValue | number:"1.0-0" | negativeNumber: "$"}}</span>
                  <span *ngIf="!hasOrders()" [ngClass]="{'negative': data.ytdTotalGainLoss < 0}">{{data.ytdTotalGainLoss | number:"1.0-0" | negativeNumber: "$"}}</span>
                </td>
          </tr>
        }

      </table>
    </div>

  </div>

  <ng-template #prComSummaryTaxInfoTemplateRef>
    The realized year-to-date gain/loss for this account is the start of day value.
  </ng-template>

  <!--div class="pr-column-box">
  <div class="pr-column" style="width: 30%">
    <table style="width: 100%;">
      <tr>
        <td style="width:134px;"><strong>Portfolio</strong></td>
        <td>
          <span id="recordPortfolioName1" *ngIf="data.portfolioDeleted">{{data.portfolioName}}</span>
          <span id="recordPortfolioName1" *ngIf="!data.portfolioDeleted"><a data-portfolio-name-link
          (click)="editPortfolio()">{{data.portfolioName}}</a></span>
        </td>
      </tr>
      <tr>
        <td><strong>Market Value</strong></td>
        <td><span id="portfolioValue">{{data.preRebalPfMktValue | number:"1.2-2" | negativeNumber: '$'}}</span></td>
      </tr>
      <tr>
        <td><strong>Current Model</strong></td>
        <td>
          <span id="recordModelName" *ngIf="data.modelDeleted">{{data.modelName}}</span>
          <span id="recordModelName" *ngIf="!data.modelDeleted"><a data-model-name-link
          (click)="editModel()">{{data.modelName}}</a></span>
        </td>
      </tr>
      <tr>
        <td><strong>Completed</strong></td>
        <td><span id="recordCompletionDate">{{data.completionDate | date: 'E MM/dd/yyyy hh:mm:ss a'}}</span></td>
      </tr>
      <tr>
        <td>
          <div style="padding-bottom: 7px;"><strong>Trade explanation</strong></div>
        </td>
        <td>
          <input type="text" pInputText id="tradeExplanation" [(ngModel)]="data.tradeExplanation" (input)="onInputChange()"/>
        </td>
      </tr>
      <tr>
        <td><strong>Last rebalance result</strong></td>
        <td id="priorRebalanceDate">{{data.latestRebalanceDate | date: 'E MM/dd/yyyy hh:mm:ss a'}}</td>
      </tr>
      <tr>
        <td><strong>Next rebalance</strong></td>
        <td *ngIf="data.schRebalanceDate">
          <span id="nextRebalanceDate">{{data.schRebalanceDate | date: 'E MM/dd/yyyy hh:mm:ss a'}}</span>
        </td>
      </tr>
      <tr *ngIf="data.schRebalanceDate && data.schRebalanceName">
        <td></td>
        <td><a href="#" id="nextRebalanceName">{{data.schRebalanceName}}</a></td>
      </tr>
    </table>
  </div>

  <div class="pr-column" style="width: 20%">
    <div class="pr-row-box">
      <table class="pr-row">
        <tr>
          <td *ngIf="data.psrNo === 0">Restrictions: 0</td>
          <td *ngIf="data.psrNo > 0"><a data-restrictions-link
          (click)="editPortfolio({restrictionsinit : true})">Restrictions: {{data.psrNo}}</a></td>
          <td *ngIf="data.hpnNo === 0">High-priority notes: 0</td>
          <td *ngIf="data.hpnNo > 0"><a data-notes-link (click)="editPortfolio({notesinit: true})">High-priority
          notes: {{data.hpnNo}}</a></td>
        </tr>
      </table>
      <div class="pr-row" style="flex-grow: 0 !important;">
        <div class="pr-table right">
          <table style="width: 240px;">
            <tr class="header">
              <td colspan="2">
                <div class="block"><strong>Pre-Rebalance</strong></div>
                <div>Realized YTD values</div>
              </td>
            </tr>
            <tr class="row">
              <td style="text-align:center; width: 50%"><strong>Total gain/loss</strong></td>
              <td class="alignRight">
                <div id="ytdTotalGainLoss" [ngClass]="{'negative': data.ytdTotalGainLoss < 0}">
                {{data.ytdTotalGainLoss | number:"1.0-0" | negativeNumber: "$"}}</div>
              </td>
            </tr>
            <tr class="row">
              <td style="text-align:center; width: 50%">Short-term</td>
              <td class="alignRight">
                <div id="ytdShortTerm" [ngClass]="{'negative': data.ytdShortTermGainLoss < 0}">
                {{data.ytdShortTermGainLoss | number:"1.0-0" | negativeNumber: "$"}}</div>
              </td>
            </tr>
            <tr class="row">
              <td style="text-align:center; width: 50%">Long-term</td>
              <td class="alignRight">
                <div id="ytdLongTerm" [ngClass]="{'negative': data.ytdLongTermGainLoss < 0}">
                {{data.ytdLongTermGainLoss | number:"1.0-0" | negativeNumber: "$"}}</div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>

  <div class="pr-column" style="width: 50%">
    <div class="pr-table right">
      <table style="width: 100%">
        <tr class="header">
          <td style="width: 40%; min-width: 200px;"></td>
          <td colspan="2"><strong>Before Advisor Edits</strong></td>
          <td colspan="2"><strong>After Advisor Edits</strong></td>
        </tr>
        <tr class="header">
          <td>Orders</td>
          <td>Qty.</td>
          <td>Value</td>
          <td>Qty.</td>
          <td>Value</td>
        </tr>
        <tr *ngFor="let row of data.orderTotalDTOList" class="row">
          <td [ngClass]="{'bold': row.sectionHdr, 'indent': !row.sectionHdr}">{{row.rowHdrStr}}</td>
          <td *ngIf="row.quantity < 0"></td>
          <td *ngIf="row.quantity >= 0" class="alignRight" [ngClass]="{'bold': row.sectionHdr}">{{row.quantity}}</td>
          <td [ngClass]="{'bold': row.sectionHdr, 'negative': row.totValue < 0}" class="alignRight">
          {{row.totValue | number:"1.2-2" | negativeNumber: "$"}}</td>
          <td *ngIf="row.userQuantity < 0" class="alignRight"></td>
          <td *ngIf="row.userQuantity >= 0" [ngClass]="{'bold': row.sectionHdr}"
          class="alignRight">{{row.userQuantity}}</td>
          <td [ngClass]="{'bold': row.sectionHdr, 'negative': row.userTotValue < 0}" class="alignRight">
          {{row.userTotValue | number:"1.2-2" | negativeNumber: "$"}}</td>
        </tr>
      </table>
    </div>
  </div>
</div-->
